import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

export interface ScrollImagesContainerProps extends PropsWithChildren {
  backgroundImage: string;
}

// Background Image is fallback for canvas, while the initial sequence is loading.
const StyledContainer = styled.div<ScrollImagesContainerProps>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  height: '100vh';
  if (backgroundImage) {
    ${({ backgroundImage }) => {
      return `background: url("${backgroundImage}") no-repeat center center;`;
    }}
  }
  background-size: cover;
`;

export const ScrollImagesContainer: React.FC<ScrollImagesContainerProps> = ({
  backgroundImage,
  children,
}) => <StyledContainer backgroundImage={backgroundImage}>{children}</StyledContainer>;
